import { render, staticRenderFns } from "./EditOrganizationFeatures.vue?vue&type=template&id=2095fb48&scoped=true"
import script from "./EditOrganizationFeatures.vue?vue&type=script&lang=js"
export * from "./EditOrganizationFeatures.vue?vue&type=script&lang=js"
import style0 from "./EditOrganizationFeatures.vue?vue&type=style&index=0&id=2095fb48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2095fb48",
  null
  
)

export default component.exports